import { useSelector, useDispatch } from "react-redux";
import { showCalibrationBanner } from "../store/actions";
import NotificationBanner from "./NotificationBanner";

const CalibrationBanner = () => {
  const dispatch = useDispatch();
  const bannerInfo = useSelector((state) => state.calibrationBanner.bannerInfo);

  if (!bannerInfo.showNotification) {
    return null;
  }

  return (
    <NotificationBanner
      notificationInfo={bannerInfo}
      setShowNotification={() => dispatch(showCalibrationBanner({ showNotification: false }))}
    />
  );
};

export default CalibrationBanner;
